import React from 'react';

import SewpatGallery from '../sewpatgallery/SewpatGalleryEmbed';
import CouponBar from './CouponBar';
import NewsLetterBar from './NewsLetterBar';
import StarterSetCartForm from '../cartforms/StarterSetCartForm';
import Text from '../common/Text';

const LandingPageBottom = () => {
    return (
        <React.Fragment>
            <NewsLetterBar />
            <StarterSetCartForm />
            <Text.Divider margin='1.61em 0 0' />
            <SewpatGallery omitActive />
            <Text.Divider margin='1.61em 0 0' />
            <CouponBar />
        </React.Fragment>
    );
};

export default LandingPageBottom;



// WEBPACK FOOTER //
// ./src/components/home/LandingPageBottom.js